import React from 'react';
import { connect } from 'react-redux';
import {Container, Message, Form, Card, Input} from "semantic-ui-react";
import Select from "react-select";
import lodash from "lodash";
import Toggle from "react-toggle";
import {
    setBillingGroupFormValues,
    setBillingGroupFormDropdownValues,
    setBillingGroupFormToggleValues,
    setBillingGroupFormDateValues}
    from "../actions/AddEditBillingGroupActions";
import * as Validation from "../../../common/utils/Validation";
import DatePicker from '../../../common/components/DatePicker';
import DocumentEditor from "../../../common/partials/DocumentEditor/DocumentEditor";


const currencies = require("../../../common/resources/currency.json");
const filteredCurrencyTypes = lodash.uniqBy(currencies, 'label');

const priceModelOptions = [
    { label: "Fixed", value: "fixed" },
    { label: "Match", value: "match" },
    { label: "Transaction", value: "transaction" }
];

const aggregationTypeOptions = [
    { label: "Country", value: "COUNTRY" },
    { label: "Global", value: "GLOBAL"},
    { label: "None", value: "NONE"}
];

export class BillingGroupForm extends React.Component {

    handleInputChange = (e, { name, value, change_object }) => {
        e.preventDefault();
        this.props.setBillingGroupForm({ name, value, change_object });
    }

    handleBillingGroupItemDropdown = (option, change_obj) => {
        this.props.setBillingGroupFormDropdown(option, change_obj);
    }

    handleBillingGroupItemToggle = (option) => {
        this.props.setBillingGroupFormToggle(option)
    }

    handleBillingGroupItemDate = day => {
        this.props.setBillingGroupFormDate({ day });
    };

    handleDismiss = () => {
        Validation.clearMessages();
    }

    render() {

        const {
            billingGroupObject,
            formMessage, formMessageHeader, formWarningNotification, formErrorNotification, formSource,
        } = this.props;

        return(
            <div className="form-page-container">
                <Container>
                    <Form>
                        <Card fluid>
                            <Card.Content>
                                <Form.Group widths={"equal"}>
                                    <Form.Field
                                        required
                                        control={Input}
                                        type="text"
                                        label="Billing Group Name"
                                        placeholder="Billing Group Name"
                                        value={billingGroupObject.billing_group_name === null ? "" : billingGroupObject.billing_group_name}
                                        name="billing_group_name"
                                        onChange={this.handleInputChange}
                                    />
                                    <Form.Field
                                        required
                                        control={Input}
                                        type="text"
                                        label="Invoice Name"
                                        placeholder="Invoice Name"
                                        value={billingGroupObject.invoice_name === null ? "" : billingGroupObject.invoice_name}
                                        name="invoice_name"
                                        onChange={this.handleInputChange}
                                    />
                                </Form.Group>
                                <div className={'required field'}>
                                    <label>Description</label>
                                    <DocumentEditor
                                        required
                                        billingGroup={true}
                                        resourceType={"description"}
                                        value={billingGroupObject.description === null ? "" : billingGroupObject.description}
                                        initialValue={billingGroupObject.description === null ? "" : billingGroupObject.description}
                                        placeholderText={"Enter Description"}
                                    />
                                </div>
                            </Card.Content>
                        </Card>

                        <Card fluid>
                            <Card.Content>
                                <h4 className="page-section-header">
                                    Pricing Info:
                                </h4>
                                <Form.Group widths={"equal"}>
                                    <Form.Field>
                                        <label>Auto Renew</label>
                                        <Toggle
                                            defaultChecked={billingGroupObject.auto_renew}
                                            onChange={() =>
                                                this.handleBillingGroupItemToggle("auto_renew")
                                            }
                                        />
                                    </Form.Field>
                                    <Form.Input
                                        required
                                        type="number"
                                        label="Platform Fee"
                                        placeholder="$"
                                        value={billingGroupObject.platform_fee === null ? "" : billingGroupObject.platform_fee}
                                        name="platform_fee"
                                        onChange={this.handleInputChange}
                                    />
                                    <Form.Field
                                        control={Input}
                                        type="text"
                                        label="Monthly Minimum Volume"
                                        placeholder="Monthly Minimum Volume"
                                        value={billingGroupObject.monthly_aggregate_volume === null ? "" : billingGroupObject.monthly_aggregate_volume}
                                        name="monthly_aggregate_volume"
                                        onChange={this.handleInputChange}
                                    />
                                </Form.Group>
                                <Form.Group widths={"equal"}>
                                    <Form.Field required={formSource !== 'DPServicesForm'}>
                                        <label>Contract Start Date</label>
                                        <DatePicker
                                            onChange={this.handleBillingGroupItemDate}
                                            value={billingGroupObject.contract_start_date}
                                            name="contract_start_date"
                                        />
                                    </Form.Field>
                                    <Form.Field
                                        control={Input}
                                        type="text"
                                        label="Contract Term (months)"
                                        placeholder="Contract Term"
                                        value={billingGroupObject.contract_term === null ? "" : billingGroupObject.contract_term}
                                        name="contract_term"
                                        onChange={this.handleInputChange}
                                    />
                                    <Form.Field
                                        control={Input}
                                        type="text"
                                        label="Notification Period (days)"
                                        placeholder="Notification Period (days)"
                                        value={billingGroupObject.cancel_days_notice === null ? "" : billingGroupObject.cancel_days_notice}
                                        name="cancel_days_notice"
                                        onChange={this.handleInputChange}
                                    />
                                </Form.Group>
                                <Form.Group widths={"equal"}>
                                    <Form.Field required={formSource !== 'DPServicesForm'}>
                                        <label>Currency</label>
                                        <Select
                                            onChange={this.handleBillingGroupItemDropdown}
                                            options={filteredCurrencyTypes}
                                            placeholder="Select Currency"
                                            isSearchable={true}
                                            isClearable={true}
                                            name="currency"
                                            getOptionLabel={(option) => `${option.label} (${option.value})`}
                                            getOptionValue={option => option.value}
                                            value={lodash.find(filteredCurrencyTypes, {
                                                value: billingGroupObject.currency
                                            })}
                                        />
                                    </Form.Field>
                                    <Form.Field required={formSource !== 'DPServicesForm'}>
                                        <label>Price Model</label>
                                        <Select
                                            onChange={this.handleBillingGroupItemDropdown}
                                            options={priceModelOptions}
                                            placeholder="Select Price Model"
                                            isSearchable={true}
                                            isClearable={true}
                                            name="price_model"
                                            getOptionLabel={option => option.label}
                                            getOptionValue={option => option.value}
                                            value={lodash.find(priceModelOptions, {
                                                value: billingGroupObject.price_model
                                            })}
                                        />
                                    </Form.Field>
                                    <Form.Field
                                        required={formSource !== 'DPServicesForm'}
                                        control={Input}
                                        type="text"
                                        label="Billing Period (months)"
                                        placeholder="Billing Period (months)"
                                        value={billingGroupObject.billing_period === null ? "" : billingGroupObject.billing_period}
                                        name="billing_period"
                                        onChange={this.handleInputChange}
                                    />
                                </Form.Group>
                                <Form.Group widths={"equal"}>
                                    <Form.Field required>
                                        <label>Volume Aggregation Type</label>
                                        <Select
                                            onChange={this.handleBillingGroupItemDropdown}
                                            options={aggregationTypeOptions}
                                            placeholder="Select Volume Aggregation Type"
                                            isSearchable={true}
                                            isClearable={true}
                                            name="volume_aggregation_type"
                                            getOptionLabel={option => option.label}
                                            getOptionValue={option => option.value}
                                            value={lodash.find(aggregationTypeOptions, {
                                                value: billingGroupObject.volume_aggregation_type
                                            })}
                                        />
                                    </Form.Field>
                                    <Form.Input
                                        required
                                        type="number"
                                        step="0.1"
                                        label="Base Price"
                                        placeholder="$"
                                        value={billingGroupObject.base_price}
                                        name="base_price"
                                        onChange={this.handleInputChange}
                                    />
                                </Form.Group>
                            </Card.Content>
                        </Card>

                    </Form>
                    {formWarningNotification || formErrorNotification
                        ? (
                            <div style={{paddingTop: "10px"}}>
                                <Message
                                    error={formErrorNotification}
                                    warning={formWarningNotification}
                                    header={formMessageHeader}
                                    list={formMessage}
                                    // hidden={formWarning}
                                    visible={formWarningNotification || formErrorNotification}
                                    onDismiss={this.handleDismiss}
                                />
                            </div>
                        )
                        : null}
                </Container>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    billingGroupObject: state.veritas.addEdit.addEditBillingGroup.billingGroupObject,
    editBillingGroup: state.veritas.addEdit.addEditBillingGroup.editBillingGroup,

    formMessage: state.marvel.message.formMessage,
    formWarningNotification: state.marvel.message.formWarningNotification,
    formErrorNotification: state.marvel.message.formErrorNotification,
    formMessageHeader: state.marvel.message.formMessageHeader,
});

const mapDispatchToProps = dispatch => ({
    setBillingGroupForm: ({ name, value }) => {
        dispatch(setBillingGroupFormValues({ name, value }))
    },
    setBillingGroupFormDropdown: (option, change_obj) => {dispatch(setBillingGroupFormDropdownValues(option, change_obj))},
    setBillingGroupFormToggle: (value) => {dispatch(setBillingGroupFormToggleValues(value))},
    setBillingGroupFormDate: ({ day }) => {dispatch(setBillingGroupFormDateValues({day}))},
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BillingGroupForm)
